import { Directive, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AlarmRuleActionDto } from '../../../../../../types/dtos/alarm-rule-action.dto';
import { BaseRuleAction } from './base-rule-action';

@Directive()
export abstract class BaseAction {
  @Input({required: true}) formGroup!: FormGroup;

  @Input() mode!: 'override' | 'edit' | 'view';

  @Input() action: AlarmRuleActionDto | undefined = undefined

  abstract ruleAction: BaseRuleAction;

  public isOverride(): boolean {
    if (this.action?.overrideConfig) {
      return true;
    }

    if (this.mode !== 'override' && this.mode !== 'edit') {
      return false;
    }

    let getConfig: Record<string, unknown> | undefined = this.getConfig()
    if (!getConfig) return false;
    let currentValues: Record<string, unknown> = this.ruleAction.formToConfig(this.formGroup.value)

    // Check the 2 Variable if value exist and diffrent return true
    if (currentValues && getConfig) {
      return this.ruleAction.isConfigDifference(currentValues, getConfig);
    }

    return false;
  }

  public getConfig(): Record<string, unknown> | undefined {
    return this.action?.config as Record<string, unknown> | undefined;
  }

  public getOverrideConfig(): Record<string, unknown> | undefined {
    return this.action?.overrideConfig;
  }

  public removeOverride(): void {
    let config: Record<string, unknown> | undefined = this.getConfig() as Record<string, unknown>

    this.formGroup.patchValue(this.ruleAction.configToFrom(config))

    if (this.action) this.action.overrideConfig = undefined
  }

}